import { isValidEmailAddress } from '../functions';
//import Swal from 'sweetalert2';

$(document).ready(function() {
    const points = {
        isLoading: false,
        init() {
            $(document).on('click', '.use-points-btn', this, this.applyPoints);
            $(document).on('click', '.remove-points-btn', this, this.removePoints);
        },
        removePoints(event) {
            event.preventDefault();

            const _this = event.data;
			let element = this;

            if (_this.isLoading) {
                return false;
            }

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
            $.ajax({
                type: "POST",
                url: `${baseURL}/cart/remove-points`,
                data: values,
                success: function(response) {
                    _this.isLoading = false;

                    if (response.status == 0) {
						Swal.fire({
							// icon: 'error',
							// title: 'Oops...',
							text: response.message
						});
                        return false;
                    }

                    if (response.status == 1) {
						// $('.points-container').remove();
                        $('.shoppingcart-main-total').text(response.data.total + ' LEI');
                        $('.order-total').text(response.data.total + ' LEI');

						$('.points-summary-amount').text('');
						$('#points-summary-container').hide();

                        return false;
                    }

					Swal.fire({
						// icon: 'error',
						// title: 'Oops...',
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                }
            });
        },
        applyPoints(event) {
            event.preventDefault();
            //event.stopImmediatePropagation();
            const _this = event.data;
			let element = this;

            if (_this.isLoading) {
                return false;
            }

            $('#points-amount').removeClass('is-invalid');

            if($('#points-amount').val() == '') {
                $('#points-amount').addClass('is-invalid');
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
            values += '&points=' + $('#points-amount').val();
            $.ajax({
                type: "POST",
                url: `${baseURL}/cart/apply-points`,
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').remove();

                    $('#points-amount').val('');

                    if (response.status == 0) {
						Swal.fire({
							// icon: 'error',
							// title: 'Oops...',
							text: response.message
						});
                        return false;
                    }

                    if (response.status == 1) {
						// $('.points-container').remove();
                        $('.shoppingcart-main-total').text(response.data.total + ' LEI');
                        $('.order-total').text(response.data.total + ' LEI');

						$('.points-summary-amount').html('-' + response.data.used_points + ' LEI <a href="javascrit:void(0)" class="remove-points-btn"><i class="fas fa-trash"></i></a>');
						$('#points-summary-container').show();

						Swal.fire({
							// icon: 'success',
							// title: 'Success...',
							text: response.message
						});
                        return false;
                    }

					Swal.fire({
						// icon: 'error',
						// title: 'Oops...',
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                    $(element).find('i').remove();
                }
            });
        }

    };

    points.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/points.js